import { mediaConfig } from './config/media';

const global = {
  MEDIA_TYPE: mediaConfig.MEDIA
}

export default global
